<template>
  <section class="container">
    <header class="header">
      <div class="logo">
        <div class="left">
          <!-- 莊氏壁立宗亲会 -->
          <!-- <img width="500px" src="../../static/icon/banner12.png" /> -->

          <!-- 大湾区金融科技总会 -->
          <!-- width="62%" -->
          <div class="left-div">
            <!-- width="72%" -->
            <!-- <img src="../../static/icon/icon_header0705.png" /> -->
            <!-- <img src="../../static/icon/logo_web@1x.png" /> -->
            <img src="../../static/icon/logo5.png" />
            <!-- <div class="left-to" @click="leftToPage('1')"></div>
            <div class="left-to-b" @click="leftToPage('2')"></div> -->
          </div>
          <!-- <img width="96px" src="../../static/icon/pic_logo.jpg" />
          <div>
            <span>{{$t('message.Home_Title')}}</span>
            <br>
            <span>{{$t('message.Home_Title_bottom')}}</span>
          </div>-->
          <!-- <div class="line-item"></div>
          <div class="item-l-a">
            <img class="img-v" src="../../static/icon/icon_header0705.png" />
          </div>
          <div class="line-item"></div>
          <div class="item-l-b">
            <img class="img-v" src="../../static/icon/icon_header0705.png" />
          </div>-->
        </div>
        <div class="right">
          <span @click="changeLang">{{ $t("message.Home_Lang") }}</span>
          <img
            src="../../static/icon/icon_jianti.svg"
            v-if="this.$i18n.locale === 'zhCHT'"
          />
          <img
            src="../../static/icon/icon_fanti.svg"
            v-if="this.$i18n.locale === 'zhCHS'"
          />
        </div>
      </div>
    </header>

    <div class="content">
      <yd-slider autoplay="5000" speed="400">
        <!-- 莊氏壁立宗亲会 -->
        <!-- <yd-slider-item>
          <a href="#"><img height="540px" src="../../static/icon/banner110.jpg" /></a>
        </yd-slider-item>
        <yd-slider-item>
          <a href="#"><img height="540px" src="../../static/icon/banner111.jpg" /></a>
        </yd-slider-item>-->

        <!-- 大湾区金融科技总会 -->
        <yd-slider-item>
          <a href="#">
            <img height="540px" src="../../static/banner/05.png" />
          </a>
        </yd-slider-item>
        <yd-slider-item>
          <a href="#">
            <img height="540px" src="../../static/banner/03.jpg" />
          </a>
        </yd-slider-item>
        <yd-slider-item>
          <a href="#">
            <img height="540px" src="../../static/banner/04.jpg" />
          </a>
        </yd-slider-item>
      </yd-slider>

      <!-- 大湾区金融科技总会 -->
      <div class="title">{{ $t("message.Home_Tc") }}</div>
      <div class="title-tc">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../static/icon/pic_2.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_3.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_4.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_5.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_6.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_7.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../static/icon/pic_1.png" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <!-- 莊氏壁立宗亲会 -->
      <!-- <div class="title">{{ $t('message.Home_objective') }}</div>
      <div>
        <div class="item-content" v-for="(item, index) in ContentList">
          <img class="image-left" :src="item.src" />
          <span class="info">{{ item.title }}</span>
        </div>
      </div>-->

      <!-- <div class="title">{{ $t('') }}</div>
      <div>
        <div class="item-content" v-for="(item, index) in ContentList">
          <img class="image-left" :src="item.src" />
          <span class="info">{{ item.title }}</span>
        </div>
      </div>-->

      <!-- <div class="title">我們的職能</div>
      <div class="flex-content">
        <div class="flex-content-child" v-for="(item, index) in ProjectList">
          <img :src="item.src" />
          <p>{{ item.title }}</p>
        </div>
      </div>-->

      <!-- <div class="ft">———————————— 更多內容即將更新，敬請期待 ————————————</div> -->

      <!-- 大湾区金融科技总会 -->
      <div class="title">{{ $t("message.Home_objective") }}</div>
      <div>
        <div
          class="item-content"
          v-for="(item, index) in ContentList"
          :key="index"
        >
          <img class="image-left" :src="item.src" />
          <span class="info">{{ item.title }}</span>
        </div>
      </div>

      <div class="title">{{ $t("message.Home_work") }}</div>
      <div class="flex-content">
        <div
          class="flex-content-child"
          v-for="(item, index) in ProjectList"
          :key="index"
        >
          <img :src="item.src" />
          <p>{{ item.title }}</p>
        </div>
      </div>

      <div class="title">{{ $t("message.Home_wish") }}</div>
      <div class="flex-content">
        <div
          class="image-hope"
          v-for="(item, index) in CommentList"
          :key="index"
        >
          <img :src="item.src" />
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="mess">
        <div class="foo-left">
          <div class="zx">
            <span>{{ $t("message.Home_Download") }}</span>
            <div class="more-download">
              <div>
                <img class="qr-code" src="../../static/icon/Android_ios.png" />
                <!-- <p><img class="plateform" src="../../static/icon/Android_ios.png"/> <span class="text-info">for iPhone</span> </p> -->
              </div>
              <!-- <div>
              <img class="qr-code" src="../../static/1555327408.png"/>
              <p><img class="plateform" src="../../static/icon/icon_android.png"/> <span class="text-info">for Android</span></p>
              </div>-->
            </div>
          </div>
          <div class="more">
            <div class="more-gz">{{ $t("message.Home_Focus") }}</div>
            <div>
              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center" class="popover-gob-item">
                  <img width="125px" src="../../static/qrcode/wxgzh24091001.png" />
                </div>
                <img slot="reference" src="../../static/icon/icon_weixin.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center" class="popover-gob-item">
                  <img width="125px" src="../../static/qrcode/weibo24091001.png" />
                </div>
                <img slot="reference" src="../../static/icon/icon_weibo.png" />
              </el-popover>

              <el-popover
                placement="bottom"
                width="300px"
                height="300px"
                trigger="hover"
              >
                <div align="center" class="popover-gob-item">
                  <img width="300px" src="../../static/qrcode/douyin24091001.png" />
                </div>
                <img slot="reference" src="../../static/icon/icon_douyin.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center" class="popover-gob-item">
                  <img width="125px" src="../../static/qrcode/ins.png" />
                </div>
                <img
                  slot="reference"
                  src="../../static/icon/icon_instagram.png"
                />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center" class="popover-gob-item">
                  <img width="125px" src="../../static/qrcode/facebook.png" />
                </div>
                <img
                  slot="reference"
                  src="../../static/icon/icon_facebook.png"
                />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center" class="popover-gob-item">
                  <img width="125px" src="../../static/qrcode/tuite.png" />
                </div>
                <img
                  slot="reference"
                  src="../../static/icon/icon_twitter.png"
                />
              </el-popover>
            </div>

            <!-- <el-popover placement="bottom" width="150" trigger="hover">
              <div align="center">
              <img width="125px" src="../../static/1555327408.png"/>
              </div>
              <img slot="reference" src="../../static/icon/qrcode/大湾区推特.png"/>
            </el-popover>-->
          </div>
          <div class="thr">
            <p>{{ $t("message.Home_Address") }}</p>
            <p class="address-en">
              Suite 2507, 25/F, Tower 6, The Gateway, 9 Canton Road, Tsim Sha
              Tsui, Hong Kong
            </p>
            <!-- <p>香港北角英皇道351-353號銀輝中心5/F，C&D室</p> -->
            <!-- 香港莊氏璧立宗親會 -->
            <!-- <p>{{ $t('message.Home_PhoneNumber') }}：852-2887 2678</p>
            <p>{{ $t('message.Home_Email') }}：biliclansmen@163.com</p>
            <p>{{ $t('message.Home_Fax') }}：852-2887 2618</p>-->
            <!-- 大湾区金融科技总会 -->
            <p>{{ $t("message.Home_PhoneNumber") }}：(852) 2528 2099</p>
            <p>{{ $t("message.Home_Fax") }}：(852) 2528 2098</p>
            <p>{{ $t("message.Home_Email") }}：info@gbafpa.com</p>
            <p>{{ $t("message.Home_Url") }}：http://www.gbafa.org</p>
          </div>
        </div>
      </div>

      <div class="bottom-info">
        <span class="copy-p">{{ $t("message.Home_Copyright") }}</span>
        <!-- <span>香港莊氏璧立宗親會 版權所有 HONGKONG CHUANGS BILI CLANSMEN ASSOCIATION</span> -->
      </div>
    </footer>
  </section>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "index",
  data() {
    return {
      langImageChs: "../../static/icon/icon_jianti.svg",
      langImageCht: "../../static/icon/icon_fanti.svg",

      // ContentList: [ // 莊氏壁立宗亲会
      //   { src: '../static/icon/icon_red.png', title: '凡屬於璧立裔孫居住香港的本會會員，須如同手足互助互濟，共解危困。本會將對此義不容辭地給予義務支持及協助，此為本會的主要宗旨。' },
      //   { src: '../static/icon/icon_blue.png', title: '聯絡居住在香港、澳門、台灣和海內外之璧立裔孫，加強聯絡，促進聯誼，從而進行經濟、文化、技術交流和合作，促進發展，共謀福祉。' },
      //   { src: '../static/icon/icon_yellow.png', title: '愛國、愛港、愛鄉，鼓勵會員和鄉親朋友積極參與社會公益事務和造福家鄉。' },
      //   { src: '../static/icon/icon_deepgreen.png', title: '本會為非牟利機構，為發展會務與實踐本會宗旨，可向會員及社會人士以及商號等籌募經費並接受捐款捐物。'},
      // ],

      // ProjectList: [ // 莊氏壁立宗亲会
      //   { src: '../static/icon/pic_pingtai.png', title: '敦亲睦族' },
      //   { src: '../static/icon/pic_qiaoliang.png', title: '造福家鄉' },
      //   { src: '../static/icon/pic_xiangmu.png', title: ' 促進發展' },
      //   { src: '../static/icon/pic_qingnian.png', title: '敬老助學' },
      //   { src: '../static/icon/pic_peixun.png', title: '社會公益' },
      // ],

      ContentList: [
        // 大湾区科技总会
        {
          src: "../static/icon/icon_red.png",
          title: this.$t("message.Home_objective_1")
        },
        {
          src: "../static/icon/icon_blue.png",
          title: this.$t("message.Home_objective_2")
        },
        {
          src: "../static/icon/icon_yellow.png",
          title: this.$t("message.Home_objective_3")
        },
        {
          src: "../static/icon/icon_deepgreen.png",
          title: this.$t("message.Home_objective_4")
        },
        {
          src: "../static/icon/icon_purple.png",
          title: this.$t("message.Home_objective_5")
        },
        {
          src: "../static/icon/icon_green.png",
          title: this.$t("message.Home_objective_6")
        },
        {
          src: "../static/icon/icon_orange.png",
          title: this.$t("message.Home_objective_7")
        }
      ],

      ProjectList: [
        // 大湾区科技总会
        {
          src: "../static/icon/pic_pingtai.png",
          title: this.$t("message.Home_work_1")
        },
        {
          src: "../static/icon/pic_qiaoliang.png",
          title: this.$t("message.Home_work_2")
        },
        {
          src: "../static/icon/pic_xiangmu.png",
          title: this.$t("message.Home_work_3")
        },
        {
          src: "../static/icon/pic_qingnian.png",
          title: this.$t("message.Home_work_4")
        },
        {
          src: "../static/icon/pic_peixun.png",
          title: this.$t("message.Home_work_5")
        },
        {
          src: "../static/icon/pic_zixun.png",
          title: this.$t("message.Home_work_6")
        },
        {
          src: "../static/icon/pic_tixi.png",
          title: this.$t("message.Home_work_7")
        }
      ],

      CommentList: [
        {
          src: "../static/icon/icon_red.png",
          title: this.$t("message.Home_wish_1")
        },
        {
          src: "../static/icon/icon_blue.png",
          title: this.$t("message.Home_wish_2")
        },
        {
          src: "../static/icon/icon_yellow.png",
          title: this.$t("message.Home_wish_3")
        },
        {
          src: "../static/icon/icon_deepgreen.png",
          title: this.$t("message.Home_wish_4")
        }
      ]
    };
  },
  mounted() {
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: true,
      // autoplay: true,
      autoplay: 2000,
      // speed: 5000,
      observer: true,
      slidePerView: "auto",
      centeredSlides: true,
      spaceBetween: 91,
      loopAdditionalSlides: 100,
      pagination: {
        el: ".swiper-pagination"
      },
      pagination: ".swiper-pagination"
    });
  },
  methods: {
    changeLang() {
      let type = sessionStorage.getItem("lang-key") || this.$i18n.locale;
      if (type === "zhCHT") {
        sessionStorage.setItem("lang-key", "zhCHS");
      } else {
        sessionStorage.setItem("lang-key", "zhCHT");
      }
      location.reload();
    },
    leftToPage(type) {
      if (type === "1") {
        window.open("https://www.heartcity.hk", "_self");
      } else if (type === "2") {
        window.open("https://www.ideasforhk.org", "_self");
      }
    }
  }
};
</script>
<style scoped>
.header {
  height: 118px;
  position: absolute;
  width: 100%;
  /* background: #fff; */
  left: 0;
  top: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.logo {
  width: 1104px;
  margin: 0 auto;
  height: 118px;
  /* line-height: 118px; */
  position: relative;
  display: flex;
  justify-content: space-between;
}
.left {
  /* width: 50%; */
  width: 80%;
  display: flex;
  align-items: center;
}
.left .left-div {
  width: 476px;
  width: 526px;
  /* width: 396px; */
  position: relative;
}
.left .left-div .left-to {
  position: absolute;
  right: 80px;
  width: 80px;
  height: 85px;
  top: 0;
  cursor: pointer;
}
.left .left-div .left-to-b {
  position: absolute;
  right: 0px;
  width: 65px;
  height: 85px;
  top: 0;
  cursor: pointer;
}
.left .line-item {
  width: 1px;
  height: 80px;
  background-color: #aaa;
  margin: 0 6px;
}
.left .left-div img {
  /* width: 100%; */
  height: 100px;
  /* height: 110px; */
}
.left .item-l-a .img-v {
  width: 111px;
  height: 120px;
}
.left .item-l-b .img-v {
  width: 111px;
  height: 120px;
}
/* .left .img-box {
  background: url(../../static/icon/icon_header621.png);
  width: 62%;
  height: 118px;
  background-size: 110% 110%;
} */
.left span {
  /* margin-left: 94px; */
  font-size: 24px;
  color: #333333;
}
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.right span {
  font-size: 18px;
  color: #333333;
  /* margin-right: 35px; */
  margin-right: 10px;
  cursor: pointer;
}
/* .left img {
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
} */
/* .right img {
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin-top: auto;
  margin-bottom: auto;
} */
.content {
  width: 1104px;
  background: #fff;
  margin: 120px auto 100px auto;
  overflow: hidden;
}
.footer {
  background: #f0f0f0;
  height: 636px;
}
.mess {
  width: 1104px;
  /* height: 200px; */
  height: 636px;
  margin: 0 auto;
}

.title {
  font-size: 34px;
  color: #333333;
  line-height: 34px;
  padding: 48px 0;
}
.title-tc {
  position: relative;
  /* overflow: hidden; */
  overflow: -webkit-paged-y;
}
.item-content {
  line-height: 60px;
  padding: 0 0 0 60px;
}
.image-left {
  display: inline-block;
  position: relative;
  top: 10px;
}
.info {
  font-size: 22px;
  color: #333333;
  line-height: 24px;
  margin-left: 24px;
}
.flex-content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.flex-content-child {
  width: 25%;
  text-align: center;
}
.flex-content-child img {
  width: 100px;
}
.flex-content-child p {
  font-size: 22px;
  color: #333333;
  padding: 30px 0;
}

.image-hope {
  width: 50%;
  position: relative;
  height: 60px;
  line-height: 60px;
  padding: 0 60px;
}
.image-hope img {
  display: inline-block;
  position: relative;
  top: 10px;
}
.image-hope span {
  font-size: 22px;
  color: #333333;
  line-height: 24px;
  margin-left: 24px;
}
.zx {
  top: 66px;
  position: relative;
}
.zx span {
  opacity: 0.8;
  font-size: 22px;
  color: #333333;
  text-align: left;
  display: inline-block;
  padding: 30px 0;
}
.more-download {
  display: flex;
  text-align: center;
}
.more-download div {
  margin: 10px 0 10px 30px;
}
.qr-code {
  width: 120px;
  height: 120px;
}
.plateform {
  width: 23px;
}
.text-info {
  font-size: 24px;
  color: #333333;
}

.more {
  position: relative;
  left: 431px;
  width: 674px;
  top: -168px;
}
.more-gz {
  margin-left: 36px;
  opacity: 0.8;
  font-size: 24px;
  color: #333333;
  padding: 30px 0;
}
.more img {
  width: 32px;
  margin-left: 32px;
}
.thr {
  position: relative;
  top: -45px;
}
.thr p {
  margin: 0 0 24px 0;
  font-size: 18px;
  color: #333333;
}

/* .thr p:nth-child(2) {
  display: inline-block;
  width: 42%;
} */
.thr p.address-en {
  padding-left: 56px;
}
.thr p:nth-child(3) {
  display: inline-block;
  width: 48%;
}
.thr p:nth-child(4) {
  display: inline-block;
  width: 42%;
}
.thr p:nth-child(5) {
  display: inline-block;
  width: 48%;
}

.bottom-info {
  background: #212121;
  height: 40px;
  line-height: 40px;
  color: white;
  text-align: center;
  font-size: 14px;
}
.bottom-info .copy-p {
  white-space: pre-wrap;
}
/*swiper*/
.swiper-container {
  /*margin-top: 0.2rem;*/
  width: 251px;
  height: 351px;
  overflow: visible !important;
  position: relative;
}
.swiper-container .swiper-wrapper .swiper-slide {
  width: 250px;
  border-radius: 0.12rem;
}
.swiper-container .swiper-wrapper .swiper-slide img {
  width: 100%;
  height: 351px;
  border-radius: 0.12rem;
}
.swiper-container .swiper-wrapper .swiper-slide-prev {
  /*margin-top: 0.18rem;*/
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-prev img {
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next {
  /*margin-top: 0.18rem;*/
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next img {
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-active {
  width: 250px;
}
.swiper-pagination {
  bottom: 0.1rem !important;
}

.ft {
  width: 100%;
  text-align: center;
  font-size: 26px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/index2.vue